import React from 'react';

export default class GameOver extends React.Component {
    render() {
        console.log("Rendering GameOver.js");
        return (
            <div>
                Game Over
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/GameOver.js